function replaceNonAlphaNumeric(x, replaceWith = ' ') {
  // Non-Alphanumeric characters are the other characters on your keyboard that aren't
  // letters or numbers, e.g. commas, brackets, space, asterisk and so on. Any character
  // that is not a number or letter (in upper or lower case) is non-alphanumeric.
  // Punctuation characters: ! @ # & ( ) – [ { } ] : ; ', ? / *
  // Symbol characters: ` ~ $ ^ + = < > “.

  // \W leaves the underscore. A short equivalent for [^a-zA-Z0-9] would be [\W_]

  const newStr = x.replace(/[\W_]+/g, replaceWith);

  return newStr;
}

export default replaceNonAlphaNumeric;
